import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'doc-format-bmp-file-icon',
  templateUrl: './doc-format-bmp-file-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class DocFormatBmpFileIconComponent {}
